function ExtractProductAttributes(){
   
    return (
        <div className="columns highlight-info">
            <div className="column col-lg-12 col-6 last-lg">
                <div className="content-wrap image-block">
                    <img src="./images/extractProductAttribute.png" className="vs-img" alt="Extract Product Attributes" />
                </div>
            </div>
            
          
            <div className="column col-lg-12 col-6">
                <div className="content-wrap">
                    <div className="mb-1 title">Extract Product attributes</div>
                    <div className="divider"></div>
                    <div className="feature-description desc col-xl-12 col-12">Visual AI identifies items within an image and extracts product attributes automatically. This enables enrichment of your product catalog without manual effort being needed, ensuring that users can search & find products with the attributes they want and also help Unbxd AI learn user affinities to recommend similar products accurately.</div>
                </div>
            </div>
        </div>
         
    )
}

export default ExtractProductAttributes;